import { useSelector } from 'core/common/hooks';
import {
  getHasUserSubscription,
  getIsActiveSubscription,
  getUserSubscriptions,
} from '../store/selectors';

export function useUserSubscriptions() {
  const hasSubscription = useSelector(getHasUserSubscription);
  const subscriptions = useSelector(getUserSubscriptions);
  const isActiveSubscription = useSelector(getIsActiveSubscription);

  return {
    hasSubscription,
    subscriptions,
    isActiveSubscription,
  };
}
